<template>
  <el-dialog
    title="创建任务"
    center
    class="devOps-modelCreate"
    :visible.sync="dialogVisible"
    width="80%"
    top="10px"
    :before-close="handleClose"
    :close-on-click-modal="false"
  >
    <el-form size="mini" ref="form" :rules="rules" :model="form" label-width="110px">
      <el-form-item label="标题" prop="title">
        <el-input placeholder="请输入任务标题" v-model="form.title"></el-input>
      </el-form-item>
      <el-form-item label="GitID" prop="git">
        <el-input
          placeholder="请输入GitLab Project ID"
          v-model.number="form.git"
        ></el-input>
      </el-form-item>
      <el-form-item label="描述">
        <Editor
          :content="form.describe"
          @contentData="changeEditContent"
          placeholder="请描述任务详情"
        />
      </el-form-item>
      <el-form-item label="模块" prop="module">
        <el-input
          placeholder="请输入开发模块（英文）"
          v-model="form.module"
        ></el-input>
      </el-form-item>
      <el-form-item label="产品" prop="user_pm">
        <el-input placeholder="请输入产品" v-model="form.user_pm"></el-input>
      </el-form-item>
      <el-form-item label="项目URL">
        <el-input
          placeholder="请输入项目Issue URL"
          v-model="form.project_url"
        ></el-input>
      </el-form-item>
      <el-form-item label="计划上线时间" prop="plt">
        <el-date-picker
          style="width: 100%"
          v-model="form.plt"
          type="datetime"
          placeholder="请选择计划上线时间"
        >
        </el-date-picker>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="onSubmit">提交</el-button>
        <el-button type="warning" @click="handleClose">返回</el-button>
        <TipOne
          class="devOps-modelCreate-tip"
          v-if="submitStatus"
          :status="submitStatus"
        />
      </el-form-item>
    </el-form>
  </el-dialog>
</template>
<script>
import { postDevopsMsgMTTaskApi } from "@/server/tops/devOps";
import { Editor } from "@/components/index.js";

import { TipOne } from "../tips/index.js";
export default {
  components: { TipOne,Editor },
  props: {
    dialogVisible: {
      type: Boolean,
      default: () => {
        return false;
      },
    },
    hideDialogVisible: {
      type: Function,
      default: () => {
        return function () {};
      },
    },
  },

  data() {
    return {
      form: {},
      rules: {
        git: [
          {
            required: true,
            message: "请输入GitLab Project ID",
            trigger: "blur",
          },
          { type: "number", message: "GitID必须为数字", trigger: "blur" },
        ],
        module: [
          {
            required: true,
            message: "请输入开发模块（英文）",
            trigger: "blur",
          },
        ],
        title: [
          {
            required: true,
            message: "请输入任务标题",
            trigger: "blur",
          },
        ],
        user_pm: [
          {
            required: true,
            message: "请输入产品",
            trigger: "blur",
          },
        ],
        plt: [
          {
            type: "date",
            required: true,
            message: "请选择计划上线时间",
            trigger: "change",
          },
        ],
      },
      submitStatus: "",
    };
  },
  mounted() {},
  methods: {
    changeEditContent(val){
      this.form.describe = val;
    },
    handleClose() {
      this.hideDialogVisible("dialogVisibleCreate");
    },
    async onSubmit() {
      this.submitStatus = "";
      this.$refs["form"].validate(async (valid) => {
        if (valid) {
          try {
            const {
              git = "",
              title = "",
              describe = "",
              module = "",
              project_url = "",
              user_pm = "",
              plt = "",
            } = this.form;
            const param = {
              git,
              title,
              describe,
              module,
              project_url,
              object_kind: "issue",
              user_pm,
              plt: plt ? this.$moment(plt).format("YYYY-MM-DD HH:mm:ss") : "",
            };
            const ret = await postDevopsMsgMTTaskApi(param);
            this.submitStatus = ret.code === 0 ? "success" : "error";
          } catch (error) {
            this.submitStatus = "error";
          }
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.devOps-modelCreate {
  .devOps-modelCreate-tip {
    margin-left: 16px;
  }
}
</style>
<style lang="scss">
.devOps-modelCreate {
  .el-input__inner {
    font-size: 14px !important;
  }
  .el-button--mini {
    padding: 12px 20px;
    font-size: 14px;
  }
  .el-dialog__header {
    border-bottom: 1px solid #efefef;
    font-weight: bold;
    padding: 20px 40px 10px;
  }
  .el-form-item__content .el-button {
    letter-spacing: 2px !important;
  }
  .el-form-item__label {
    font-weight: bold;
  }
}
</style>